import script from "./MatchSubjectsApplyInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchSubjectsApplyInfo.vue?vue&type=script&setup=true&lang=js"

import "./MatchSubjectsApplyInfo.vue?vue&type=style&index=0&id=a1db3440&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1db3440"]])

export default __exports__